const tpl = require('../templates/error_list.html')
const scroll = require('../widgets/scroll')

const error_console = window.$('.error-console')
const body = window.$(document.body)
const url = error_console.attr('data-endpoint')
const target = error_console.find('.target')
const tbody = target.find('tbody')

body.on('fetch', function(ev) {
  target.addClass('loading')
})

if (error_console.length) {
  scroll(target, url, tpl, 10)
    .on('data', target.removeClass.bind(target, 'loading'))
    .on('data', function(data) {
      tbody.append(data)
    })
}

body.removeClass('preload')

body.on('click', '[rel="console-toggle"]', toggle_console)

function toggle_console(ev) {
  ev.preventDefault()

  if (body.is('.console-on')) {
    body.removeClass('console-on info-on').addClass('console-off')
  } else {
    if (!tbody.children('*').length) {
      target.trigger({type: 'empty'})
    }

    body.removeClass('console-off info-on').addClass('console-on')
  }
}
